import { render, staticRenderFns } from "./SDA.vue?vue&type=template&id=7b6a883c&scoped=true"
import script from "./SDA.vue?vue&type=script&lang=js"
export * from "./SDA.vue?vue&type=script&lang=js"
import style0 from "./SDA.vue?vue&type=style&index=0&id=7b6a883c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a883c",
  null
  
)

export default component.exports